// Maps a show's raw scheduling-cadence value to the week-interval badge shown
// next to the curator name in the schedule calendar (e.g. "Iain Chambers (1)").
// The number is how many weeks apart the show airs; "irregular" has no fixed
// interval and renders as "N/a".
const FREQUENCY_BADGE_MAP: Record<string, string> = {
  weekly: "1",
  bimonthly: "2",
  monthly: "4",
  "week-1": "1",
  "week-2": "2",
  "week-4": "4",
  "week-8": "8",
  every2weeks: "2",
  every4weeks: "4",
  irregular: "N/a",
};

export const getFrequencyBadge = (frequency?: string | null): string | null => {
  if (!frequency) return null;
  return FREQUENCY_BADGE_MAP[frequency.trim().toLowerCase()] ?? null;
};

// Whether two shows air on the same cadence. Both sides must have a known
// frequency: identical raw values match, and synonyms that map to the same
// week-interval badge (e.g. "weekly" and "week-1") also match. A missing or
// unrecognised frequency on either side is treated as "not the same", so
// callers that gate on equal frequency stay on the safe side.
export const sameFrequency = (
  a?: string | null,
  b?: string | null
): boolean => {
  const na = (a ?? "").trim().toLowerCase();
  const nb = (b ?? "").trim().toLowerCase();
  if (!na || !nb) return false;
  if (na === nb) return true;
  const badgeA = getFrequencyBadge(a);
  const badgeB = getFrequencyBadge(b);
  return badgeA !== null && badgeB !== null && badgeA === badgeB;
};
